<template src="./template.html"></template>

<script>
export default {
  name: "HomeGallery",
  data() {
    return {}
  }
}
</script>